export default "__VITE_ASSET__055cfbd7__"